import React from "react";
import { Row } from "react-materialize";
import { trans } from "../../Lang";
import NewsItem from "./NewsItem";

const BLOG_SITE = "smileundpindonesia.wordpress.com";

class BlogSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: [],
      postItems: [],
    };
  }

  componentDidMount() {
    this.fetchBlogPostFeeds();
  }

  fetchBlogPostFeeds = (e) => {
    fetch(
      `https://public-api.wordpress.com/rest/v1/sites/${BLOG_SITE}/posts/?number=3`
    ).then((response) => {
      if (response.ok)
        response.json().then((result) => this.parsePostData(result.posts));
    });
  };

  parsePostData = (postData) => {
    let postItems = [];
    const imgRegex = /src="(.*?)"/;
    //imgRegex
    postData.map((post) => {
      let docs = new DOMParser().parseFromString(post.content, "text/html");
      let docText = docs.body.textContent.trim();
      postItems.push({
        url: post.URL,
        src: imgRegex.exec(post.content)[1],
        author: post.author.first_name,
        title: post.title,
        content: docText.substring(0, docText.indexOf("\n")),
      });
    });
    this.setState({ postItems: postItems });
  };

  render() {
    return (
      <div className="bg-white pad-xl">
        <div className="container">
          <Row>
            <div className="blueText center">
              <b>{trans.news}</b>
            </div>
          </Row>
          <br />
          <Row>
            {this.state.postItems &&
              this.state.postItems.map((item, index) => <NewsItem key={"news-" + index} data={item} />)}
          </Row>
          <Row>
            <div className="center">
              <a href={`https://${BLOG_SITE}`} className="btn blueButton1">
                {trans.other_news}
              </a>
            </div>
          </Row>
        </div>
      </div>
    );
  }
}

export default BlogSection;



// WEBPACK FOOTER //
// ./src/components/Public/Home/BlogSection.js